<template>
  <div>
    <navbar></navbar>
    <div style="margin: 70px 30px 30px 60px">
      <div class="row w-100 ml-0 mr-0">
        <div class="sellProRataTitle d-flex">
          <div style="cursor: pointer" @click="goBack()">
            <i class="fas fa-arrow-left user-font mr-2 material-icon-font"></i>
          </div>
          <div class="my-auto">Sell Positions</div>
        </div>
      </div>
      <div class="row w-100 ml-0 mr-0" style="margin: 10px 0px 10px 0px">
        <div class="sellProRataCaption" style="margin-left: 26px">
          By selecting "sell positions" you will share : company name, your
          name, amount you are selling, date of last fundraise with a fiifi
          representative.
        </div>
      </div>
      <div class="row w-100 ml-0 mr-0" style="margin-bottom: 10px">
        <div class="d-flex" style="margin-left: 26px">
          <div class="sellProRataNoteTitle">Note</div>
          <div class="sellProRataNoteTitle ml-1 mr-1">:</div>
          <div class="sellProRataNoteTitle ml-1 brokerText">
            We are not a broker dealer, solicitor or make money based on volume
            of transaction, we are not offering to buy or sell any positions. We
            are a software services that attempts to match buyers and sellers
            through licensed dealers and our data room, we do not have access to
            data rooms or any details to transactions.
          </div>
        </div>
      </div>
      <div
        class="d-flex"
        style="justify-content: flex-end; margin-bottom: 30px"
      >
        <div>
          <button
            class="newTask"
            style="height: 36px; margin-left: 22px"
            @click="download"
          >
            <i class="fa fa-download" aria-hidden="true"></i>Download CSV
          </button>
        </div>
      </div>
      <div class="row w-100 ml-0 mr-0" style="margin-bottom: 30px">
        <div id="theMainTableSummary" class="w-100">
          <div
            class="tabulator lp-tabulator-cls"
            ref="sellProRataRefTable"
            style="width: 100%; height: 100%"
          ></div>
        </div>
      </div>
    </div>
    <el-dialog
      left
      width="750px"
      title="Confirmation"
      :closeOnClickModal="false"
      :closeOnPressEscape="false"
      @close="handleCancelConfirmation"
      :showClose="true"
      :visible.sync="showConfirmationDialog"
      class="sellProrataConfirmation"
    >
      <div style="padding: 0px 15px 0px 15px">
        <div class="row w-100 ml-0 mr-0">
          <div class="sellProRataModalText">
            fiifi will only share company name, sector amount available, current
            round of funding, current share price, and company valuation.
            <br />
            Please add in the pro rata details if they are different then what
            is shown below, when you confirm, you will have an opportunity to
            draft a message to recipients before sending.
            <br />
          </div>
        </div>
        <div class="row w-100 ml-0 mr-0" style="margin-top: 18px">
          <div class="sellProRataCaption" style="color: #000000">
            Company Details
          </div>
        </div>
        <div class="row w-100 ml-0 mr-0" style="margin: 20px 0px 20px 0px">
          <table class="portfolioPerformanceTable fix-fields-container w-100">
            <tr class="portfolioPerformanceTableHeading">
              <th>COMPANY</th>
              <th>Ownership ($)</th>
              <th>Valuation ($)</th>
              <th>Round Size ($)</th>
              <th>Pre Money ($)</th>
              <th>Post Money ($)</th>
              <th>Pro Rata ($)</th>
              <th>Selling ($)</th>
            </tr>
            <tr
              v-for="(item, index) in selectedData"
              :key="index"
              class="portfolioPerformanceTableLoop"
            >
              <td>
                <div class="d-flex">
                  <img
                    style="
                      border-radius: 50%;
                      margin-right: 5px;
                      height: 35px;
                      width: 35px;
                    "
                    :src="getImageUrl(item.companyLogoUrl)"
                  />
                  <div class="line-height-1">{{ item.companyName }}</div>
                </div>
              </td>
              <td>
                <input
                  type="number"
                  class="form-control"
                  v-model="item.ownership"
                  placeholder="Enter Round Size"
                />
              </td>
              <td>
                <input
                  type="number"
                  class="form-control"
                  v-model="item.valuation"
                  placeholder="Enter Round Size"
                />
              </td>

              <td>
                <input
                  type="number"
                  class="form-control"
                  v-model="item.roundSize"
                  placeholder="Enter Round Size"
                />
              </td>

              <td>
                <input
                  type="number"
                  class="form-control"
                  v-model="item.preMoney"
                  placeholder="Enter Pre Money"
                />
              </td>

              <td>
                <input
                  type="number"
                  class="form-control"
                  v-model="item.postMoney"
                  placeholder="Enter Post Money"
                />
              </td>

              <td>
                <input
                  type="number"
                  class="form-control"
                  v-model="item.proRata"
                  placeholder="Enter Pro-Rata"
                />
              </td>

              <td>
                <input
                  type="number"
                  class="form-control"
                  v-model="item.selling"
                  placeholder="Enter selling $"
                />
              </td>
            </tr>
          </table>
        </div>

        <div class="row w-100 ml-0 mr-0" style="margin-bottom: 7px">
          <div class="d-flex">
            <div style="margin-right: 10px">
              <input id="tAndC" type="checkbox" v-model="confirmCheckBox" />
            </div>
            <label for="tAndC" class="sellProRataModalText">
              By selecting confirm you are agreeing to our
              <a href="https://fiifi.co/terms-of-service/" target="_blank"
                >terms of service</a
              >
            </label>
          </div>
        </div>

        <div class="row w-100 ml-0 mr-0" style="margin-bottom: 7px">
          <div class="d-flex">
            <div class="d-flex">
              <div style="margin-right: 10px">
                <input
                  type="checkbox"
                  v-model="sendToContacts"
                  id="sendToContacts"
                />
              </div>
              <label for="sendToContacts" class="sellProRataModalText"
                >Send to Contacts</label
              >
            </div>
            <div class="d-flex" style="margin-left: 20px">
              <div style="margin-right: 10px">
                <input type="checkbox" v-model="sendToFiifi" id="sendToFiifi" />
              </div>
              <label for="sendToFiifi" class="sellProRataModalText"
                >Send to Fiifi</label
              >
            </div>
          </div>
        </div>

        <div
          class="row w-100 ml-0 mr-0"
          style="margin-bottom: 15px"
          v-if="sendToFiifi"
        >
          <div class="sellProRataModalText">
            We take your privacy seriously. We only share the above data with
            trusted partners and only upon double opt in make introductions via
            a certified broker dealer.
          </div>
        </div>

        <div class="row w-100 ml-0 mr-0" style="margin-bottom: 30px">
          <promotion-contact-card
            :workspaceId="workspaceId"
            :getSelectedContacts="getSelectedContacts"
            v-if="sendToContacts"
            @selectedContacts="handleSelectedContacts"
            @contactValidity="handleContactValidity"
          ></promotion-contact-card>
        </div>

        <div class="text-right">
          <button
            type="button"
            style="height: 35px"
            class="todo-form-submit-button btn btn-primary"
            @click="handleConfirm()"
            :disabled="
              showSpinner ||
              !confirmCheckBox ||
              (!sendToContacts && !sendToFiifi) ||
              (sendToContacts && !isContactValid)
            "
          >
            Confirm
            <b-spinner
              v-if="showSpinner"
              style="float: right"
              small
              label="Loading..."
            ></b-spinner>
          </button>
        </div>
      </div>
    </el-dialog>

    <el-dialog
      left
      width="750px"
      title=""
      :closeOnClickModal="false"
      :closeOnPressEscape="false"
      @close="handleCancelConfirmation"
      :showClose="true"
      :visible.sync="showViewDealDialog"
      class="sellProrataConfirmation"
    >
      <div style="padding: 0px 15px 0px 15px">
        <div class="row w-100 ml-0 mr-0" style="margin-top: 18px">
          <div class="sellProRataCaption" style="color: #000000">
            Company Details
          </div>
        </div>
        <div class="row w-100 ml-0 mr-0" style="margin: 20px 0px 20px 0px">
          <table class="portfolioPerformanceTable fix-fields-container w-100">
            <tr class="portfolioPerformanceTableHeading">
              <th>COMPANY</th>
              <th>Ownership</th>
              <th>Valuation</th>
              <th>Round Size</th>
              <th>Pre Money</th>
              <th>Post Money</th>
              <th>Pro Rata</th>
              <th>Selling ($)</th>
            </tr>
            <tr class="portfolioPerformanceTableLoop">
              <td>
                <div class="d-flex">
                  <img
                    style="
                      border-radius: 50%;
                      margin-right: 5px;
                      height: 35px;
                      width: 35px;
                    "
                    :src="getImageUrl(dealData.companyLogoUrl)"
                  />
                  <div class="line-height-1">{{ dealData.companyName }}</div>
                </div>
              </td>
              <td>
                {{ dealData.ownership }}
              </td>
              <td>
                {{ dealData.valuation }}
              </td>

              <td>
                {{ dealData.roundSize }}
              </td>

              <td>
                {{ dealData.preMoney }}
              </td>

              <td>
                {{ dealData.postMoney }}
              </td>

              <td>
                {{ dealData.proRata }}
              </td>

              <td>
                {{ dealData.selling }}
              </td>
            </tr>
          </table>
        </div>

        <div class="row w-100 ml-0 mr-0" style="margin-top: 18px">
          <div class="sellProRataCaption" style="color: #000000">
            Information Sent To
          </div>
        </div>
        <div class="row w-100 ml-0 mr-0" style="margin: 20px 0px 20px 0px">
          <table class="portfolioPerformanceTable fix-fields-container w-100">
            <tr class="portfolioPerformanceTableHeading">
              <th>NAME</th>
              <th>EMAIL</th>
              <th>SENT ON</th>
            </tr>

            <tr
              v-for="(contact, index) in dealData.contacts"
              :key="index"
              class="portfolioPerformanceTableLoop"
            >
              <td>
                {{ contact.name }}
              </td>
              <td>
                {{ contact.email }}
              </td>

              <td>
                {{ formatDate(contact.sentOn) }}
              </td>
            </tr>
          </table>
        </div>

        <div v-if="sendToMoreContacts">
          <div class="row w-100 ml-0 mr-0" style="margin-bottom: 7px">
            <div class="d-flex">
              <div style="margin-right: 10px">
                <input id="tAndC" type="checkbox" v-model="confirmCheckBox" />
              </div>
              <label for="tAndC" class="sellProRataModalText">
                By selecting confirm you are agreeing to our
                <a href="https://fiifi.co/terms-of-service/" target="_blank"
                  >terms of service</a
                >
              </label>
            </div>
          </div>

          <div class="row w-100 ml-0 mr-0" style="margin-bottom: 7px">
            <div class="d-flex">
              <div class="d-flex">
                <div style="margin-right: 10px">
                  <input
                    type="checkbox"
                    v-model="sendToContacts"
                    id="sendToContacts"
                  />
                </div>
                <label for="sendToContacts" class="sellProRataModalText"
                  >Send to Contacts</label
                >
              </div>
              <div class="d-flex" style="margin-left: 20px">
                <div style="margin-right: 10px">
                  <input
                    type="checkbox"
                    v-model="sendToFiifi"
                    id="sendToFiifi"
                  />
                </div>
                <label for="sendToFiifi" class="sellProRataModalText"
                  >Send to Fiifi</label
                >
              </div>
            </div>
          </div>

          <div
            class="row w-100 ml-0 mr-0"
            style="margin-bottom: 15px"
            v-if="sendToFiifi"
          >
            <div class="sellProRataModalText">
              We take your privacy seriously. We only share the above data with
              trusted partners and only upon double opt in make introductions
              via a certified broker dealer.
            </div>
          </div>

          <div class="row w-100 ml-0 mr-0" style="margin-bottom: 30px">
            <promotion-contact-card
              :workspaceId="workspaceId"
              :contactsToSkip="dealData.contacts || []"
              :getSelectedContacts="getSelectedContacts"
              v-if="sendToContacts"
              @selectedContacts="handleSelectedContacts"
              @contactValidity="handleContactValidity"
            ></promotion-contact-card>
          </div>

          <div class="text-right">
            <button
              type="button"
              style="height: 35px"
              class="todo-form-submit-button btn btn-primary"
              @click="handleConfirm()"
              :disabled="
                showSpinner ||
                !confirmCheckBox ||
                (!sendToContacts && !sendToFiifi) ||
                (sendToContacts && !isContactValid)
              "
            >
              Confirm
              <b-spinner
                v-if="showSpinner"
                style="float: right"
                small
                label="Loading..."
              ></b-spinner>
            </button>
          </div>
        </div>

        <div class="text-right">
          <button
            v-if="showBtnSendToMoreContacts"
            type="button"
            style="height: 35px; width: auto"
            class="todo-form-submit-button btn btn-primary"
            @click="
              sendToMoreContacts = true;
              showBtnSendToMoreContacts = false;
            "
          >
            Send To More Contacts
          </button>
        </div>
      </div>
    </el-dialog>

    <el-dialog
      left
      title
      :closeOnClickModal="false"
      :closeOnPressEscape="false"
      :showClose="false"
      width="300px"
      style="margin: 0 auto"
      :visible.sync="showLoader"
      class="loadingModal col-lg-12 col-sm-12 col-12 col-md-12"
    >
      <div style="text-align: center">
        <div>
          <b-spinner
            style="width: 7rem; height: 7rem; color: #5445f3"
            class="mt-5"
            label="Large Spinner"
          ></b-spinner>
        </div>
        <div style="margin-top: 15px; color: #000">Loading...</div>
      </div>
    </el-dialog>

    <el-dialog
      left
      title
      :closeOnClickModal="false"
      :closeOnPressEscape="false"
      @close="handleCancelSendEmail"
      :showClose="true"
      width="525px"
      style="margin: 0 auto"
      :visible.sync="showEmailContentDialog"
      class="col-lg-12 col-sm-12 col-12 col-md-12"
    >
      <div class="row">
        <!-- <div class="col-12"> -->
        <div class="col-12">
          <div>
            Email:
            <span class="required">*</span>
          </div>
          <!-- <input
                  type="text"
                  v-model="value.data.title"
                  class="todo-form form-control"
                  style="width: 100%;"
                  required
                  placeholder="Task"
                />-->
          <fieldset
            data-concat-into="concatinated"
            class="todo-form-fieldSet todo-form form-control"
          >
            <div>
              <input
                type="text"
                required
                placeholder="Email Subject"
                class="todo-form-fieldSet-input"
                v-model="emailSubjectText"
              />
              <!-- </div> -->
              <hr
                style="
                  color: #707070;
                  margin-top: 0.5rem !important;
                  margin-bottom: 0.5rem !important;
                "
              />
              <!-- <div> -->
              <textarea
                placeholder="Email"
                required="required"
                rows="4"
                cols="50"
                class="todo-form-fieldSet-textArea form-control"
                v-model="emailBodyText"
              ></textarea>
            </div>
          </fieldset>
        </div>

        <div class="col-12 text-right">
          <button
            type="button"
            style="height: 35px"
            class="todo-form-submit-button btn btn-primary"
            @click="handleSendEmail()"
          >
            Send
          </button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import NavbarNew from "../Layout/NavbarNew";
import api from "../../../axios_api";
import Tabulator from "tabulator-tables";
import moment from "moment";
import config from "../../../../config/settings";
import { mapGetters } from "vuex";
import { numberSorter } from "./investments";
import { Dialog, Select, Option } from "element-ui";
import { formatNumberWithComma } from "../../../util";
const DATA_STATUS_CONFIRMED = "Confirmed";
const DATA_STATUS_UNCONFIRMED = "Unconfirmed";
const DATA_STATUS_UPDATING = "Retrieving";

import ContactCard from "../../../components/Cards/Promotions/ContactCard";

export default {
  name: "sellProRata",
  components: {
    [NavbarNew.name]: NavbarNew,
    [Dialog.name]: Dialog,
    [Select.name]: Select,
    [Option.name]: Option,
    [ContactCard.name]: ContactCard,
  },
  computed: {
    ...mapGetters("user", ["currency", "firstName", "lastName"]),
    ...mapGetters("user", ["user"]),
    ...mapGetters("workspace", ["sellProRataData"]),
    ...mapGetters("workspace", ["buyProRataData"]),
    moment() {
      return moment;
    },
    workspaceId() {
      return this.selectedData[0] ? this.selectedData[0].workspace : "";
    },
    tableData() {
      let self = this;
      let data = JSON.parse(JSON.stringify(self.sellProRataData));
      if (data.length == 0) {
        return [];
      }
      data.map((item, index) => {
        let dealIndex = self.buyProRataData.findIndex((itm) => {
          if (itm && item.portfolio_item == itm.portfolio_item) {
            return itm;
          }
        });
        if (dealIndex >= 0) {
          item.sent = true;
          item.sentdealDate = self.buyProRataData[dealIndex].created
            ? moment(self.buyProRataData[dealIndex].created).format(
                "MM/DD/YYYY"
              )
            : "";
        } else {
          item.sent = false;
        }
        item.companyLogoUrl = item.companyLogoUrl
          ? item.companyLogoUrl
          : "static/img/generic-logo.png";
        item.id = index;
        item.selling = 0;
        item.latestRoundDate = item.latestRoundDate
          ? moment(item.latestRoundDate).format("MM/DD/YYYY")
          : "-";
        let logoUrl = this.getImageUrl(item.companyLogoUrl);
        if (item.companyDataStatus == DATA_STATUS_CONFIRMED) {
          item.nameLogoString = `
                <div class="d-flex">
                    <img src="${logoUrl}" style="width: 35px;height: 35px;border-radius: 50%;" class="company-img"/>
                    <img src="static/img/confirmed.svg" class="company-statys-img"/>
                            <b style="margin-left: 48px;overflow:hidden;whitespace:nowrap;text-overflow:ellipsis;">${item.companyName}  </b> <a style="color: #00000080;overflow:hidden;whitespace:nowrap;text-overflow:ellipsis;">-${item.companyStatus}</a>
                </div>

            `;
        }
        if (item.companyDataStatus == DATA_STATUS_UNCONFIRMED) {
          item.nameLogoString = `
                <div class="d-flex">
                    <img src="${logoUrl}" style="width: 35px;height: 35px;border-radius: 50%;" class="company-img"/>
                    <img src="static/img/warning.svg" class="company-statys-img"/>
                            <b class="ml-5" style="overflow:hidden;whitespace:nowrap;text-overflow:ellipsis;">${item.companyName} </b> <a style="color: #00000080;overflow:hidden;whitespace:nowrap;text-overflow:ellipsis;">-${item.companyStatus}</a>
                </div>
            `;
        }
        if (item.companyDataStatus == DATA_STATUS_UPDATING) {
          item.nameLogoString = `
                <div class="d-flex">
                    <img src="${logoUrl}" style="width: 35px;height: 35px;border-radius: 50%;" class="company-img"/>
                    <img src="static/img/retrieving.svg" class="company-statys-img"/>
                            <b class="ml-5" style="overflow:hidden;whitespace:nowrap;text-overflow:ellipsis;">${item.companyName} </b> <a style="color: #00000080;overflow:hidden;whitespace:nowrap;text-overflow:ellipsis;">-${item.companyStatus}</a>
                </div>
            `;
        }
      });
      return data;
    },
    tableOptions() {
      const self = this;
      return {
        layout: "fitColumns",
        tooltips: true,
        data: this.tableData,
        columns: this.tableColumns,
        tooltips: true,
        layoutColumnsOnNewData: true,
        index: "id",
        pagination: "local",
        paginationSize: 20,
        paginationSizeSelector: true,
        placeholder: "No records to view",
        virtualDom: false,
        rowSelectionChanged: function (data, rows) {
          self.selectedData = data;
        },
        selectableCheck: function (row) {
          //row - row component
          return !row.getData().sent ? true : false;
        },
      };
    },
    tableColumns() {
      const self = this;
      return [
        // {
        //   formatter: function (cell, params) {
        //     let data = cell.getData();
        //     return !data.sent ? `<input type="checkbox" />` : "";
        //   },
        //   align: "left",
        //   width: "20",
        //   headerSort: false,
        //   download: false,
        //   cellClick: function (e, cell) {
        //     cell.getRow().toggleSelect();
        //   },
        // },
        {
          title: "Company Name",
          field: "companyName",
          sorter: "string",
          download: true,
          visible: false,
        },
        {
          title: "Company",
          field: "nameLogoString",
          sorter: function (a, b, aRow, bRow, column, dir, sorterParams) {
            let first = aRow.getData().companyName || "";
            let second = bRow.getData().companyName || "";
            return first.localeCompare(second);
          },
          responsive: 0,
          resizable: false,
          width: "260",
          download: false,
          formatter: "html",
          headerSort: false,
          tooltip: function (cell) {
            let tootipData = `${cell._cell.row.data.companyName} - ${cell._cell.row.data.companyStatus}`;
            return tootipData;
          },
        },
        {
          title: "Ownership (%)",
          field: "ownership",
          sorter: "number",
          resizable: false,
          download: true,
          responsive: 0,
          formatter: function (cell, params) {
            if (_.isNumber(cell.getValue()) && cell.getValue() !== 0)
              return cell.getValue() + "%";
            else if (_.isNil(cell.getValue()) || cell.getValue() == 0)
              return "N/A";
            return cell.getValue();
          },
        },
        {
          title: "Cost ($)",
          field: "cost",
          sorter: numberSorter,
          formatter: "money",
          resizable: false,
          formatterParams: this.currency.format,
          responsive: 0,
          download: true,
        },
        {
          title: "Value ($)",
          field: "value",
          sorter: numberSorter,
          resizable: false,
          formatter: "money",
          formatterParams: this.currency.format,
          responsive: 0,
          download: true,
        },
        {
          title: "PPS",
          field: "price_per_share",
          sorter: numberSorter,
          resizable: false,
          formatter: "money",
          formatterParams: this.currency.format,
          responsive: 0,
          download: true,
        },
        {
          title: "valuation",
          field: "postMoney",
          sorter: numberSorter,
          resizable: false,
          formatter: "money",
          formatterParams: this.currency.format,
          responsive: 0,
          download: true,
        },
        {
          title: "Round Invested",
          field: "round",
          sorter: "string",
          resizable: false,
          download: true,
        },
        {
          title: "Workspace Name",
          field: "workspaceName",
          sorter: "string",
          resizable: false,
          download: true,
        },
        {
          minWidth: 100,
          resizable: false,
          headerSort: false,
          responsive: 0,
          download: false,
          tooltip: false,
          formatter: function (cell, params) {
            let data = cell.getData();
            return !data.sent
              ? `<button class="newTask">Sell Position</button>`
              : `<div style='color:#78DE87'>Sent - ${
                  data.sentdealDate || ""
                } <span class="fa fa-eye pointer link"></span></div>`;
          },
          cellClick: function (e, cell) {
            self.selectedData = [cell.getData()];
            self.company = cell.getData();

            self.showViewDealDialog = false;
            self.showConfirmationDialog = false;

            if (!self.company.sent) {
              self.clearData();
              self.showConfirmationDialog = true;
            } else {
              self.showViewDealDialog = true;
              self.getDealByPortfolioItemId(cell.getData());
            }
          },
        },
      ];
    },
  },
  data() {
    return {
      company: {},
      tabulator: null,
      isContactValid: false,
      showConfirmationDialog: false,
      showViewDealDialog: false,
      sendToMoreContacts: false,
      showBtnSendToMoreContacts: true,
      dealData: {},
      showSpinner: false,
      showLoader: false,
      selectedData: [],
      confirmCheckBox: false,
      sendToFiifi: false,
      contactsToSend: [],
      sendToContacts: false,
      getSelectedContacts: false,
      showEmailContentDialog: false,
      emailSubjectText: "",
      emailBodyText: "",
    };
  },
  methods: {
    formatNumberWithComma,
    goBack() {
      this.$router.go(-1);
    },
    getImageUrl(image) {
      if (!image) {
        return;
      }
      // image.includes(
      //  "https://res-3.cloudinary.com/crunchbase-production/image/upload"
      //) ||
      if (
        image.includes(config.CRUNCHBASE_IMAGE_URL) ||
        image.includes("https://res") ||
        image.includes("static/img/generic-logo.png")
      ) {
        return image;
      }
      let imageId = image.slice(image.lastIndexOf("t_api_images/") + 13);
      if (!imageId || imageId.length == 0) {
        return image;
      }
      return `${config.CRUNCHBASE_IMAGE_URL}/${imageId}`;
    },
    handleContactValidity(val) {
      this.isContactValid = val;
    },
    handleCancelConfirmation() {
      this.company = {};
      this.showConfirmationDialog = false;
      this.showViewDealDialog = false;

      this.selectedData = [];
      this.dealData = {};
      this.contactsToSend = [];
      this.emailSubjectText = "";
      this.emailBodyText = "";

      this.sendToMoreContacts = false;
      this.showBtnSendToMoreContacts = true;

      this.showSpinner = false;
      this.confirmCheckBox = false;
      this.isContactValid = false;
      this.sendToContacts = false;
      this.sendToFiifi = false;
      this.confirmCheckBox = false;
    },
    clearData() {
      const self = this;

      if (self.selectedData[0]) {
        self.selectedData[0].ownership = 0;
        self.selectedData[0].valuation = 0;
        self.selectedData[0].roundSize = 0;
        self.selectedData[0].preMoney = 0;
        self.selectedData[0].postMoney = 0;
        self.selectedData[0].proRata = 0;
        self.selectedData[0].selling = 0;
      }
    },
    handleCancelSendEmail() {
      this.showEmailContentDialog = false;
      return;
    },
    handleSelectedContacts(data) {
      this.contactsToSend = data;

      if (this.contactsToSend && this.contactsToSend.length) {
        for (let i = 0; i < this.contactsToSend.length; i++) {
          if (!this.contactsToSend[i].email) {
            self.$toaster.error("Please add correct email");
            return false;
          }
        }
      }

      this.handleSave();
    },
    handleConfirm() {
      this.emailSubjectText = `Fiifi | Investment Opportunity - ${
        this.selectedData[0].companyName
      } | By ${this.user.firstName} ${this.user.lastName || ""}`;

      this.emailBodyText = `We have watched this company grow and flourish over the last several years, and
      have concluded one follow won with them. They have a great team and I've a lot of respect for the CEO.
      Please reach out if you are interested and we are happy to share more.`;

      this.showEmailContentDialog = true;
    },

    handleSendEmail() {
      if (this.sendToContacts) {
        this.getSelectedContacts = !this.getSelectedContacts;
        this.showEmailContentDialog = false;
        return;
      }

      this.handleSave();
      this.showEmailContentDialog = false;
    },

    handleSave() {
      const self = this;
      this.showSpinner = true;

      // send email to contacts
      if (this.sendToContacts) {
        this.contactsToSend.forEach((item) => {
          const emailBody = self.composeEmailBody(item, false);
          this.sendEmail(item.email, emailBody, this.emailSubjectText);
        });
      }

      // send to fiifi
      if (this.sendToFiifi) {
        const emailBodyForFiifi = self.composeEmailBody(null, true);
        config.DEAL_ROOM_EMAILS.forEach((systemEmail) => {
          this.sendEmail(
            systemEmail,
            emailBodyForFiifi,
            this.emailSubjectText + ` | ${config.ENVIRONMENT}`
          );
        });
      }

      // save data
      if (this.showViewDealDialog) {
        this.updateDeal();
      } else {
        this.createDeal();
      }
    },

    composeEmailBody(contact, isToFiifiFounder) {
      let self = this;

      // sender infor
      let senderInfo = ``;
      let sentToList = ``;

      senderInfo = `
        <div>
          You are receiving the email because ${self.user.firstName} ${
        self.user.lastName || ""
      } would like to share 
          their pro rata position with you as you might be interested in investing. This information is highly 
          confidential and should only be communicated with ${
            self.user.firstName
          } ${self.user.lastName || ""}. If you are 
          interested to further the conversation please reply to 
          this email.
        </div><br/>`;

      if (isToFiifiFounder) {
        sentToList = `<div>This email is also sent to following contacts: <br/>`;
        this.contactsToSend.forEach((item) => {
          sentToList += `${item.name} &lt;${item.email}&gt;<br/>`;
        });
        sentToList += `</div>`;

        senderInfo += sentToList;
      }

      let emailBodyData = "";

      let companyData;
      if (this.showViewDealDialog) {
        companyData = this.dealData;
      } else {
        companyData = this.selectedData[0];
      }

      if (companyData) {
        let companyNameHTML = ``;
        if (
          companyData.companyPermalink &&
          companyData.companyPermalink.length > 0
        ) {
          companyNameHTML = `<a href='${config.SHARED_PORTFOLIO_URL}/${companyData.companyPermalink}' target='_blank'>${companyData.companyName}</a>`;
        } else {
          companyNameHTML = `${companyData.companyName}`;
        }

        emailBodyData += `
            <tr>
              <td>${companyNameHTML}</td>
              <td>${companyData.companySector}</td>
              <td>${companyData.round}</td>
              <td>$${companyData.valuation || 0}</td>
              <td>$${companyData.roundSize || 0}</td>
              <td>$${companyData.preMoney || 0}</td>
              <td>$${companyData.postMoney || 0}</td>
              <td>$${companyData.selling}</td>
            </tr>`;
      }

      let emailNote = `
      <div>
        <br/>
        <b>Note to investor:</b>
        <br/>
        ${this.emailBodyText}
        <br/>
      </div>`;

      const companyInfo = `<table>
          <tr>
            <th>Company</th>
            <th>Sector</th>
            <th>Round</th>
            <th>Valuation</th>
            <th>Round Size</th>
            <th>Pre Money</th>
            <th>Post Money</th>
            <th>Selling</th>
          </tr>
          ${emailBodyData}
        </table>`;

      let emailBody = `<!DOCTYPE html>
        <html>
        <head>
        <style>
        table {
          font-family: arial, sans-serif;
          border-collapse: collapse;
          width: 100%;
        }

        td, th {
          border: 0px solid #dddddd;
          text-align: left;
          padding: 8px;
        }
        </style>
        </head>
        <body>

          <table border="0" cellpadding="0" cellspacing="0" width="100%">
            <tbody>
                <tr>
                    <td align="center" valign="top">
                        <table border="0" cellpadding="0" cellspacing="0" width="100%"
                            style="background:#ffffff 0% 0% no-repeat padding-box;border:1px solid #0000001a;border-radius:5px 5px 0px 0px;opacity:1">
                            <tbody>
                                <tr>
                                    <td align="center">
                                        <table class="m_1877859841133214385container" border="0" cellpadding="0" cellspacing="0"
                                            width="100%" height="70" style="background-color:#593bfd;height:70px">
                                            <tbody>
                                                <tr>
                                                    <td style="text-align:center;padding:15px 0px 15px 0px">
                                                        <img style="height:40px;width:75px"
                                                            src="https://assets.fiifi-dev.com/logo.png" class="CToWUd">
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </td>
                                </tr>

                                <tr>
                                    <td align="center">
                                        <table align="center"  class="m_1877859841133214385container" border="0" cellpadding="0" cellspacing="0"
                                            width="100%" style="background-color:#ffffff;width:600px;height:auto">
                                            <tbody>
                                                <tr>
                                                    <td
                                                        style="font-style:normal;font-variant:normal;font-weight:400;font-size:30px;line-height:36px;letter-spacing:0.6px;opacity:1;text-align:center;padding-top:30px;padding-bottom:20px;color:#593bfd">
                                                        Investment Opportunity
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </td>
                                </tr>
                                <tr>
                                    <td align="center">
                                      ${senderInfo}
                                      <div style="border: 2px solid #593bfd; border-radius: 4px;padding: 10px;margin:10px 0px;">
                                        ${emailNote}

                                        ${companyInfo}
                                      </div>
                                    </td>
                                </tr>
                                <tr>

                                  <td style="text-align: center; padding: 20px 20%;">
                                    This message is provided by fiifi; are not a broker dealer, solicitor or make money 
                                    based on volume of transaction, we are not offering to buy or sell any positions. 
                                    We are a software services that attempts to match buyers and sellers through licensed
                                    dealers and our users, we do not have access to data rooms or any details to 
                                    transactions.
                                  </td>
                                </tr>
                            </tbody>
                        </table>
                    </td>
                </tr>
                <tr>
                    <td align="center" valign="top">
                        <table border="0" cellpadding="0" cellspacing="0" width="100%"
                            style="background:#eaedfa 0% 0% no-repeat padding-box;border:1px solid #0000001a;opacity:1;padding:30px 40px;border-spacing:0">
                            <tbody>
                                <tr>
                                    <td align="center" valign="top">
                                        <table align="center" border="0" cellpadding="0" cellspacing="0" width="100%"
                                            style="border-spacing:0">
                                            <tbody>
                                                <tr>
                                                    <td style="font-size:0">&nbsp;</td>
                                                    <td style="font-size:0">&nbsp;</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </td>
                                </tr>

                                <tr>
                                    <td align="center" valign="top">
                                        <table align="center" border="0" cellpadding="0" cellspacing="0" width="100%"
                                            style="border-spacing:0">
                                            <tbody>
                                                <tr>
                                                    <td style="font-size:0">&nbsp;</td>
                                                    <td align="center" style="width:272px">
                                                        <table border="0" cellpadding="0" cellspacing="0" width="100%"
                                                            style="padding-top:25px;border-collapse:separate;border-spacing:0">
                                                            <tbody>
                                                                <tr>
                                                                    <td align="center"
                                                                        style="text-align:center;padding:0px;padding-bottom:0px;font-style:normal;font-variant:normal;font-weight:400;font-size:12px;line-height:28px;letter-spacing:0px;color:#000000;opacity:0.5">
                                                                        Copyright © 2020 <span class="il">fiifi</span>. All
                                                                        rights reserved.
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <td align="center"
                                                                        style="text-align:center;padding:0px;white-space:nowrap;font-style:normal;font-variant:normal;font-weight:400;font-size:12px;line-height:28px;letter-spacing:0px;color:#000000;opacity:0.5">
                                                                        <a align="center"
                                                                            style="padding:0px;color:#593bfd;text-decoration:none;font-style:normal;font-variant:normal;font-weight:400;font-size:12px;line-height:28px;letter-spacing:0px;opacity:0.95"
                                                                            href="https://fiifi.co/" target="_blank"><span
                                                                                class="il">fiifi</span></a>
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </td>
                                                    <td style="font-size:0">&nbsp;</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </td>
                </tr>
            </tbody>
          </table>
        </body>
        </html>`;

      return emailBody;
    },

    sendEmail(toEmail, emailBody, emailSubject) {
      api
        .post("/generic/send/email", {
          encrypt: {
            data: {
              emails: [toEmail],
              subject: emailSubject,
              html: emailBody,
            },
          },
        })
        .then((emailData) => {})
        .catch((error) => {
          console.log("error in adding deals", error);
        });
    },

    createDeal() {
      let self = this;

      api
        .post(`deals/${self.$route.params.account_id}`, {
          encrypt: {
            data: JSON.parse(
              JSON.stringify({
                deals: self.selectedData,
                oldContacts: self.sendToContacts
                  ? self.contactsToSend.filter((item) => item._id)
                  : [],
                newContacts: self.sendToContacts
                  ? self.contactsToSend.filter((item) => item.tempId)
                  : [],
                sendToFiifi: self.sendToFiifi,
                sendToContacts: self.sendToContacts,
              })
            ),
          },
        })
        .then((data) => {
          this.refreshData();
        })
        .catch((error) => {
          console.log("error in adding deals", error);
          self.$toaster.error("Failed to update");
          this.showLoader = false;
        });
    },

    updateDeal() {
      let self = this;

      api
        .put(`deals/${self.$route.params.account_id}`, {
          encrypt: {
            data: JSON.parse(
              JSON.stringify({
                deals: self.selectedData,
                dealRecord: self.dealData,
                oldContacts: self.sendToContacts
                  ? self.contactsToSend.filter((item) => item._id)
                  : [],
                newContacts: self.sendToContacts
                  ? self.contactsToSend.filter((item) => item.tempId)
                  : [],
                sendToFiifi: self.sendToFiifi,
                sendToContacts: self.sendToContacts,
              })
            ),
          },
        })
        .then((data) => {
          this.refreshData();
        })
        .catch((error) => {
          console.log("error in adding deals", error);
          self.$toaster.error("Failed to update");
          this.showLoader = false;
        });
    },

    refreshData() {
      let self = this;
      self.$store
        .dispatch("workspace/apiFetchBuyProRataData", {
          account_id: self.$route.params.account_id,
        })
        .then((buyData) => {
          self.$store
            .dispatch("workspace/apiFetchSellProRataData", {
              account_id: self.$route.params.account_id,
            })
            .then((sellData) => {
              self.tabulator.replaceData(self.tableOptions.data);
              self.handleCancelConfirmation();
              self.$toaster.success("Sent Successfully");
              this.selectedData = [];
            })
            .catch((error) => {
              console.log("error in sell data in adding deals", error);
              self.$toaster.error("Failed to update");
            });
        })
        .catch((error) => {
          console.log("error in buy data in adding deals", error);
          self.$toaster.error("Failed to update");
        });
    },

    getDealByPortfolioItemId(portfolioItem) {
      const foundData = this.buyProRataData.filter((item) => {
        return item.portfolio_item === portfolioItem.portfolio_item;
      });

      if (foundData.length) {
        this.dealData = foundData[0];
      }
    },

    download() {
      let currentTime = new Date().toLocaleString().split(", ").join("_");
      let fileName = `${this.user.firstName}_${this.user.lastName}_${currentTime}`;
      this.tabulator.download("csv", `${fileName}.csv`);
      this.$toaster.success("Downloaded Successfully");
    },
    valuationText(postMoney) {
      if (!postMoney) {
        return "";
      }
      if (Number(postMoney) > 0) {
        return `$${this.formatNumberWithComma(Number(postMoney))}`;
      } else if (Number(postMoney) < 0) {
        return `-$${this.formatNumberWithComma(Number(postMoney))}`;
      } else {
        return "";
      }
    },
    formatDate(dt) {
      return moment(dt).format("MM/DD/YYYY");
    },
  },
  mounted() {
    let self = this;
    const titleEl = document.querySelector("head title");
    titleEl.textContent = `Fiifi | Sell Positions`;
    if (this.$route.params.account_id) {
      self.showLoader = true;
      self.$store.dispatch("workspace/apiFetchBuyProRataData", {
        account_id: self.$route.params.account_id,
      });
      self.$store
        .dispatch("workspace/apiFetchSellProRataData", {
          account_id: self.$route.params.account_id,
        })
        .then((data) => {
          if (self.$refs.sellProRataRefTable && self.tableOptions) {
            self.tabulator = new Tabulator(
              self.$refs.sellProRataRefTable,
              self.tableOptions
            );
            self.showLoader = false;
          }
        });
    }
  },
  watch: {
    tableOptions: {
      handler: function (newData) {
        if (this.tabulator) {
          this.tabulator.replaceData(this.tableOptions.data);
        }
      },
    },
  },
};
</script>
<style>
.sellProrataConfirmation .el-dialog__header {
  padding: 30px 30px 20px 30px;
}
.sellProrataConfirmation .el-dialog__body {
  padding-top: 0px;
}
.brokerText {
  color: #00000080;
  word-break: break-word;
}
</style>